function sentenceCase(s: string): string {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function formatPeriodLabel(period: string | null | undefined): string {
  if (!period) return '';
  try {
    const parts = period.split(' to ');
    if (parts.length < 2 || !parts[0] || !parts[1]) return sentenceCase(period);
    const start = new Date(parts[0].trim());
    const end = new Date(parts[1].trim());
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return sentenceCase(period);
    }
    const fmt = (d: Date) => d.toLocaleString('en-US', { month: 'short' });
    return `${fmt(start)} \u2013 ${fmt(end)} ${end.getFullYear()}`;
  } catch {
    return sentenceCase(period);
  }
}

export function formatRange(from?: string | null, to?: string | null): string {
  if (!from && !to) return '';
  const parse = (s?: string | null) => {
    if (!s) return null;
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  };
  const start = parse(from);
  const end = parse(to);
  if (start && end) {
    const sameYear = start.getFullYear() === end.getFullYear();
    const fmtMonthDay = (d: Date) =>
      d.toLocaleString('en-US', { month: 'short', day: 'numeric' });
    if (sameYear) {
      return `${fmtMonthDay(start)} \u2013 ${fmtMonthDay(end)}, ${end.getFullYear()}`;
    }
    const fmtFull = (d: Date) =>
      d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    return `${fmtFull(start)} \u2013 ${fmtFull(end)}`;
  }
  return `${from ?? '\u2014'} to ${to ?? '\u2014'}`;
}
